<!-- Botón oficial de ClaveÚnica según lineamientos de Gobierno Digital -->
<!-- https://wikiguias.digital.gob.cl/guias/BotónCU -->
<div class="button-wrapper">
  <button
    class="btn-cu btn-m btn-color-estandar"
    type="button"
    (click)="onLogin()"
    [disabled]="!isConfigured"
    id="#"
    aria-label="Continuar con ClaveÚnica"
  >
    <span class="cl-claveunica" aria-hidden="true"></span>
    <span class="texto" aria-hidden="true">ClaveÚnica</span>
  </button>

  @if (!isConfigured) {
    <p class="config-warning" role="alert" aria-live="polite">
      ⚠️ ClaveÚnica no está configurado. Verifica las variables de entorno.
    </p>
  }
</div>
